import useRightPanelRedesign from '@/containers/SubscriptionFormPageNew/Components/shared/RightPanel/useRightPanelRedesign'
import { PANEL_HEADER_HEIGHT } from '@/containers/SubscriptionFormPageNew/Components/shared/RightPanel/styled-components'
import { FLOATING_GAP } from '@/shared/theme/styled-components'
import useClientTabRedesign from './useClientTabRedesign'
import {
  pulseAddButtonOverrides,
  pulseClientTabOverrides,
  pulseContractTabOverrides,
  pulseTabOverrides,
  pulseTabsOverrides,
} from './styled-components'

const useTabBarStyle = ({ clientTabHasUnsavedChanges = false } = {}) => {
  const rightPanelRedesignEnabled = useRightPanelRedesign()
  const isPulse = useClientTabRedesign()
  const tabRowHeight = rightPanelRedesignEnabled
    ? { height: PANEL_HEADER_HEIGHT, paddingTop: 0, paddingBottom: 0, boxSizing: 'border-box' }
    : {}
  const tabStyle = {
    Tab: {
      style: ({ $isActive }) => ({
        borderRadius: '0.5rem 0.5rem 0 0',
        marginRight: '0.3rem',
        backgroundColor: $isActive ? 'white' : 'lightgrey',
        fontWeight: 'bold',
        fontSize: '1rem',
        ...tabRowHeight,
      }),
    },
    TabPanel: {
      style: () => ({
        backgroundColor: 'white',
        borderRadius: '0 0.5rem 0.5rem 0.5rem',
        paddingTop: '24px',
        paddingBottom: '24px',
        paddingLeft: '24px',
        paddingRight: '24px',
        display: 'flex',
        alignItems: 'flex-start',
        gap: '48px',
        alignSelf: 'stretch',
      }),
    },
  }

  const addButtonStyle = {
    BaseButton: {
      style: {
        backgroundColor: 'lightgrey',
        color: 'rgb(65, 71, 78);',
        borderBottomLeftRadius: '0',
        borderBottomRightRadius: '0',
        fontWeight: 'bold',
        ...tabRowHeight,
        ':hover': {
          backgroundColor: 'white',
          color: 'rgb(65, 71, 78);',
        },
      },
    },
  }

  const tabsOverrides = {
    TabBorder: {
      style: () => ({
        height: '0rem',
      }),
    },
    TabHighlight: {
      style: () => ({
        display: 'none',
      }),
    },
    TabList: {
      style: () => ({
        flexGrow: '0',
      }),
    },
    EndEnhancerContainer: {
      style: () => ({
        marginLeft: '0.1rem',
      }),
    },
  }

  const mainContainerStyle = {
    display: 'flex',
    flexDirection: 'inline-flex',
    gap: rightPanelRedesignEnabled ? FLOATING_GAP : '24px',
    alignItems: 'flex-start',
  }

  const tabsContainerStyle = {
    ...(rightPanelRedesignEnabled ? { flex: '1 1 auto', minWidth: 0 } : { width: '75%' }),
    flexDirection: 'column',
    alignItems: 'flex-start',
  }

  if (isPulse) {
    return {
      isPulse,
      tabStyle: pulseTabOverrides,
      clientTabStyle: pulseClientTabOverrides(clientTabHasUnsavedChanges),
      contractTabStyle: pulseContractTabOverrides,
      tabsOverrides: pulseTabsOverrides,
      mainContainerStyle,
      tabsContainerStyle,
      addButtonStyle: pulseAddButtonOverrides,
    }
  }

  return {
    isPulse,
    tabStyle,
    clientTabStyle: null,
    contractTabStyle: tabStyle,
    tabsOverrides,
    mainContainerStyle,
    tabsContainerStyle,
    addButtonStyle,
  }
}

export default useTabBarStyle
